import React from "react"
import { EnkMsgDialogContext, IEnkMsgDialogContextType } from "./msgdialog-provider"

export const useMsgDialog = (): IEnkMsgDialogContextType => {
  const context = React.useContext(EnkMsgDialogContext)

  if (!context) {
    throw new Error("useMsgDialog must be used within an EnkMsgDialogProvider")
  }

  return context
}
